export default __webpack_public_path__ + "static/char-s-21-ja-2c1572e20b598b75683bf3736e404b02.webp";